import { render, staticRenderFns } from "./CoOwnershipSales.vue?vue&type=template&id=1ab17e26"
import script from "./CoOwnershipSales.vue?vue&type=script&lang=js"
export * from "./CoOwnershipSales.vue?vue&type=script&lang=js"
import style0 from "./CoOwnershipSales.vue?vue&type=style&index=0&id=1ab17e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports